import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useEffect } from 'react';
const AuthContext = createContext(undefined);
export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const fetchUser = async () => {
        try {
            const response = await fetch('/api/auth/me', {
                credentials: 'include',
            });
            if (response.ok) {
                const data = await response.json();
                setUser(data.user);
            }
            else {
                setUser(null);
            }
        }
        catch (error) {
            console.error('Failed to fetch user:', error);
            setUser(null);
        }
        finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchUser();
    }, []);
    const login = () => {
        // Redirect to Atlassian OAuth
        window.location.href = '/api/auth/atlassian';
    };
    const logout = async () => {
        try {
            await fetch('/api/auth/logout', {
                method: 'POST',
                credentials: 'include',
            });
            setUser(null);
        }
        catch (error) {
            console.error('Logout failed:', error);
        }
    };
    const refetch = async () => {
        await fetchUser();
    };
    return (_jsx(AuthContext.Provider, { value: { user, loading, login, logout, refetch }, children: children }));
}
export function useAuth() {
    const context = useContext(AuthContext);
    if (context === undefined) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
}
//# sourceMappingURL=AuthContext.js.map